import React, { useState, useEffect } from "react";
import Parse from "parse";
import { getParameterByName } from "../utils/formatter";

import "../styles/service-steps.css";

import number1 from "../assets/step-item-1.svg";
import number2 from "../assets/step-item-2.svg";
import number3 from "../assets/step-item-3.svg";
import {selectBusinessTerms} from "../utils/image";

export default function ServiceSteps() {
    const [isBusiness, setIsBusiness] = useState(false);

    useEffect(() => {
        const checkBusiness = async () => {
            const businessId = getParameterByName("business");
            try {
                const business = await new Parse.Query("Business").get(
                    businessId
                );
                if (business) setIsBusiness(business);
            } catch (e) {}
        };
        checkBusiness();
    }, []);

    const checkCoppy = (businessId) => {
        switch (businessId) {
            case "ZF5WZAbvQ6":
                return(
                    <>
                    <div className="step-item">
                        <img src={number1} alt="1" />
                        <p className="title">Elige el tipo de servicio</p>
                        <p>
                            Escoge entre las siguientes categorías el servicio que más se ajuste a tus necesidades
                        </p>
                    </div>
                    <div className="step-item">
                        <img src={number2} alt="2" />
                        <p className="title">Explica los detalles.</p>
                        <p>
                            Compara precios, valoraciones y experiencia para elegir al profesional que mejor se ajusta a tus necesidades.
                        </p>
                    </div>
                    <div className="step-item">
                        <img src={number3} alt="3" />
                        <p className="title">Confirma y nos ponemos en marcha.</p>
                        <p>
                            Podrás llevar el seguimiento del proceso en todo momento desde tu APP, email y Whatsapp.
                        </p>
                    </div>
                    </>
                )
                break;
        
            default:
                return(
                    <>
                    <div className="step-item">
                        <img src={number1} alt="1" />
                        <p className="title">Publica tu solicitud</p>
                        <p>
                            Recibirás hasta 3 presupuestos de nuestros Profesionales sin compromiso.
                        </p>
                    </div>
                    <div className="step-item">
                        <img src={number2} alt="2" />
                        <p className="title">Escoge a tu Profesional</p>
                        <p>
                        Compara precios, valoraciones y experiencia para elegir al profesional que mejor se ajusta a tus necesidades.
                        </p>
                    </div>
                    <div className="step-item">
                        <img src={number3} alt="3" />
                        <p className="title">Paga y valora</p>
                        <p>
                        Una vez resuelta tu solicitud, paga al Profesional por la App y déjale una valoración.
                        </p>
                    </div>
                    </>
                )
                break;
        }
    }

    return (
        <div className="row">
            <div id="service-steps" className="hidden-md hidden-sm hidden-xs">
                {checkCoppy(isBusiness.id)}
            </div>
            {/*{selectBusinessTerms(getParameterByName("business"))}*/}
        </div>
    )
}
